<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title"/>
  </div>
</template>

<script>
// import {saveLocalStorage} from './utils/webCache'

export default {
  name: 'App',
  data () {
    return {
      loading: this.$store.state.common.loading
    }
  },
  created () {
    const loading = document.getElementById('first-loading')
    if (loading != null) {
      document.body.removeChild(loading)
    }
  },
  mounted () {
    // console.log(process.env.WX_CONFIG.WX_APP_ID)
  },
  destroyed () {
    // saveLocalStorage('time', null)
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/App.vue